export default {
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts(data1, data2, data3, data4, data5) {
      var chartDom2 = this.$refs.chart;
      var myChart2 = this.$echarts.init(chartDom2);
      var option2 = {
        tooltip: {
          // trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "5%",
          left: "10%",
          textStyle: {
            color: "#fff"
          }
        },
        color: ["#F39858", "#F85F88", "#FE017F", "#A300FE", "#29CF4B"],
        series: [{
          name: "种植面积",
          type: "pie",
          center: ["60%", "50%"],
          //饼图位置
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: true,
            length: 20,
            length2: 30,
            lineStyle: {
              color: "#aaa"
            }
          },
          data: [{
            value: 6,
            name: "草莓"
          }, {
            value: 3,
            name: "葡萄"
          }, {
            value: 5.3,
            name: "火龙果"
          }, {
            value: 1,
            name: "桃李子"
          }, {
            value: 2.3,
            name: "蔬菜"
          }, {
            value: 0.7,
            name: "多肉植物"
          }, {
            value: 1.7,
            name: "地栽草莓"
          }]
        }]
      };
      myChart2.setOption(option2);
    }
  }
};